// extracted by mini-css-extract-plugin
var _1 = "BoardActions_action__4ShVr";
var _2 = "BoardActions_actionFlex__5+0MQ";
var _3 = "BoardActions_actionRightFirst__M9cxM";
var _4 = "BoardActions_actionRightLast__sLNN5";
var _5 = "BoardActions_active__y6+4Q";
var _6 = "BoardActions_cardsCount__xFf8S";
var _7 = "BoardActions_githubAction__MbwzQ";
var _8 = "BoardActions_githubGreen__HjN62";
var _9 = "BoardActions_githubGrey__8XjmR";
var _a = "BoardActions_switchViewButton__kCknZ";
var _b = "BoardActions_title__jMP-z";
var _c = "BoardActions_wrapper__rxxRn";
export { _1 as "action", _2 as "actionFlex", _3 as "actionRightFirst", _4 as "actionRightLast", _5 as "active", _6 as "cardsCount", _7 as "githubAction", _8 as "githubGreen", _9 as "githubGrey", _a as "switchViewButton", _b as "title", _c as "wrapper" }
